module.exports = __webpack_public_path__ + "img/q-women.a62905c7.png";